import decodeJwt from "jwt-decode";

import { identifyUser } from "../services/MixpanelService";
import { ApiService } from "../services/AutoOnboardingApiService";
import { setUserData as setGoogleUserData } from "../services/GoogleTracker";
import { ROLE_TYPES } from "../enums/Roles";
import { OneSignalService } from "../services/OneSignal";

export const forceLogout = () => {
  localStorage.clear();
  window.location.href = "/";
  window.location.reload();
};

export const setAuthData = async (token, firstTime = false) => {
  localStorage.setItem("token", token);
  const decodedToken = decodeJwt(token);
  const role = decodedToken.role;
  localStorage.setItem("role", role);
  localStorage.setItem("user", JSON.stringify(decodedToken));

  if (role === ROLE_TYPES.RESTAURANT_DRAFT) {
    // mixpanel
    identifyUser(decodedToken, firstTime);
    // google
    setGoogleUserData(decodedToken);
    // oneSignal
    OneSignalService.registerUser(decodedToken);
  }

  if (!decodedToken.restaurant) return;

  const restaurant = await ApiService.fetchRestaurant();
  if (!restaurant) {
    forceLogout();
    return;
  }
  localStorage.setItem("restaurant", JSON.stringify(restaurant));
  return;
};

export const validateAuthorization = (res) => {
  if (res.status === 401 || res.status === 403) {
    forceLogout();
    throw new Error("Unauthorized");
  }
};

export const validateResponse = (res) => {
  if (res.status < 200 || res.status >= 300) {
    validateAuthorization(res);
    throw new Error(res.json());
  }
  return true;
};

export const getUserDataFromToken = (key) => {
  const token = localStorage.getItem("token");
  const decodedToken = decodeJwt(token);
  return key ? decodedToken[key] : decodedToken;
};

export const getRestaurantData = () => {
  const restaurant = localStorage.getItem("restaurant");
  return restaurant ? JSON.parse(restaurant) : null;
};
